(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('CompanyDetailController', CompanyDetailController);

    CompanyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'entityAudit', 'CompanyCustomService', 'Company', 'Location', 'Contact', '$uibModal'];

    function CompanyDetailController($scope, $rootScope, $stateParams, previousState, entity, entityAudit, CompanyCustomService, Company, Location, Contact, $uibModal) {
        var vm = this;


        vm.company = entity;
        vm.audits = entityAudit;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:companyUpdate', function(event, result) {
            vm.company = result;
            //Audits
            CompanyCustomService.returnCompanyAuditById( result.id ).then( function( data ) {
                vm.audits = data.data;
            }, function( error ) {
                console.log(error.status, error.statusText);
            });
        });
        $scope.$on('$destroy', unsubscribe);

        vm.createTab = function( data ) {
            $scope.$emit('handleEmit', data );
        };

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        vm.editCompany = function() {
            $uibModal.open({
                templateUrl: 'app/entities/company/company-dialog.html',
                controller: 'CompanyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['Company', function(Company) {
                        return Company.get({id : $stateParams.id}).$promise;
                    }],
                    showTypes: function () {
                        return true;
                    }
                }
            }).result.then(function() {

            }, function() {

            });
        };
    }
})();
